module.exports = __webpack_public_path__ + "static/media/map.9629c2e9.png";